import styled from 'styled-components';

import { themeColorWithOpacity, themeZIndex } from '../../../theme/getters';
import { fadeInTransition } from '../../../theme/transitions';

export const Container = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  z-index: ${themeZIndex('overlay')};
  display: flex;
  align-items: center;
  justify-content: center;
  will-change: transform;

  &:before {
    content: '';
    top: -50vh;
    left: -50vh;
    bottom: -50vh;
    right: -50vh;
    position: fixed;
    ${fadeInTransition};
    background: ${themeColorWithOpacity('primary', 0.25)};
  }
`;
